import React, { useContext } from 'react';
import moment from 'moment/moment';
import { UserContext } from 'venn-components';
import { AlertNote } from 'venn-ui-kit';
import { useHasFF } from 'venn-utils';
import { PanelItem } from '../components/shared';

const getIsNewUser = (created: number | undefined) => {
  return moment.utc(created).isSameOrAfter(moment.utc('2025-10-29'));
};

export const InputTutorialMessage = () => {
  const { profileSettings } = useContext(UserContext);
  const isNewUser = getIsNewUser(profileSettings?.user.created);
  const hasBlockAssignment = useHasFF('block_assignment_ff');

  if (isNewUser || !hasBlockAssignment) {
    return null;
  }

  return (
    <PanelItem>
      <AlertNote size="small">Set subjects, date ranges, and benchmarks in the Inputs panel.</AlertNote>
    </PanelItem>
  );
};
